// extracted by mini-css-extract-plugin
module.exports = {"customBlockContent":"custom-block-content-module--custom-block-content--zEd4j"};